import {all} from 'redux-saga/effects';
import bannerTemplateActionWatcher from "./banner/template/saga";
import organizationActionWatcher from "./organizations/saga";
import feedActionWatcher from "./feed/saga";
import bannerVariablesActionWatcher from "./banner/variables/saga";
import userActionWatcher from "./user/saga";
import fileSystemActionWatcher from "./files/saga";
import fileDataActionWatcher from "./files/filedata/saga";

export default function* rootSaga() {
    yield all([
        bannerTemplateActionWatcher(),
        bannerVariablesActionWatcher(),
        organizationActionWatcher(),
        feedActionWatcher(),
        userActionWatcher(),
        fileSystemActionWatcher(),
        fileDataActionWatcher(),
    ]);
}